import styled from "@emotion/styled";
import Sidebar from "../sidebar";
import React, {ReactNode, useState} from "react";
import TopBar from "../topbar";
import {DrawerType} from "../../types/types";
import RightDrawers from "../sidebar/RightDrawers";
import {isTokenExpired} from "../../services/auth";
import {useTestParams} from "../../pages/tests/useTestParams";

const DefaultLayout = ({children}: { children: ReactNode }) => {

  useTestParams();
  const [rightDrawerType, setRightDrawerType] = useState<DrawerType | undefined>(undefined);

  const openRightDrawer = (type: DrawerType | undefined) => {
    setRightDrawerType(type);
  }

  const hasValidToken = !isTokenExpired();

  return (
    <Layout>
      {
        hasValidToken ? (
          <>
            <RightDrawers drawerType={rightDrawerType} openDrawer={openRightDrawer}/>
            <TopBar drawerType={rightDrawerType} openDrawer={openRightDrawer}/>
            <Sidebar/>
            <Content>
              {children}
            </Content>
          </>
        ) : (
          <TokenVerification>Token-Verifizierungsprozess läuft</TokenVerification>
        )
      }

    </Layout>
  );
}

const Layout = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 80px;
  height: calc(100vh - 80px);
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  display: block;
  height: 100%;
  flex: 1;
  overflow: auto;
`;

const TokenVerification = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export default DefaultLayout;